import React, { useState } from 'react';

export interface ThumbnailPreviewFrameProps {
  src?: string;
  alt?: string;
  /** Placeholder content when no image URL (pending file name, icon, etc.) */
  children?: React.ReactNode;
  maxWidth?: number;
  maxHeight?: number;
  className?: string;
}

/**
 * Flexible thumbnail preview — supports landscape and portrait images without cropping.
 */
const ThumbnailPreviewFrame: React.FC<ThumbnailPreviewFrameProps> = ({
  src,
  alt = '',
  children,
  maxWidth = 260,
  maxHeight = 200,
  className = '',
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className={`thumbnail-preview-frame mx-auto ${className}`.trim()}
      style={{
        width: '100%',
        maxWidth,
        minHeight: 120,
        maxHeight: maxHeight + 16,
        padding: 8,
        borderRadius: 12,
        background: 'linear-gradient(145deg, #f1f5f9 0%, #e2e8f0 100%)',
        boxShadow: 'inset 0 0 0 1px rgba(148, 163, 184, 0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
          onLoad={() => setLoaded(true)}
          style={{
            maxWidth: '100%',
            maxHeight,
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            borderRadius: 8,
            boxShadow: loaded ? '0 4px 12px rgba(15, 23, 42, 0.12)' : undefined,
            display: 'block',
          }}
        />
      ) : (
        children
      )}
    </div>
  );
};

export default ThumbnailPreviewFrame;
